import { render, staticRenderFns } from "./BaseRichTextEditorInput.vue?vue&type=template&id=c0737846&scoped=true&"
import script from "./BaseRichTextEditorInput.vue?vue&type=script&lang=js&"
export * from "./BaseRichTextEditorInput.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&id=c0737846&scoped=true&lang=css&"
import style1 from "./BaseRichTextEditorInput.vue?vue&type=style&index=1&id=c0737846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0737846",
  null
  
)

export default component.exports